import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client.service';
import { OrderService } from 'src/app/services/order.service';
import { SystemService } from 'src/app/services/system.service';

@Component({
  selector: 'app-exchange-rs',
  templateUrl: './exchange-rs.component.html',
  styleUrls: ['./exchange-rs.component.scss'],
})
export class ExchangeRsComponent implements OnInit {

  form: FormGroup;
  valueBalanceReal = 0.00;
  valueBalanceBs = 0.00;
  valueBalanceDolar = 0.00;

  valueBsDay = 0.00;
  valueUsDay = 0.00;
  feeExchangeBs = 0.00;
  feeExchangeUs = 0.00;

  customerValue = 0.00;
  customerFee = 0.00;

  targetCoin = 2;
  amount;
  result: any;

  constructor(private fb: FormBuilder, private toastCtrl: ToastController, private loadingCtrl: LoadingController,
    private systemSerevice: SystemService, private clientService: ClientService,
    private orderService: OrderService, private navCtrl: NavController) {
    this.form = this.fb.group({
      value: ['', Validators.compose([
        Validators.required,
      ])],
    });
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    //Carrega o saldo da carteira
    this.loadBalanceRs();
    this.loadBalanceBs();
    this.loadBalanceUs();

    //Carregar dados para cambio de reais a bs
    this.loadValueRsBs();
    this.loadFeeExchangeRSBs();

    //Carregar dados para cambio de reais a dolar
    this.loadValueRsUs();
    this.loadFeeExchangeRsUs();

    loading.dismiss();

  }

  changeTargetCoin(value) {
    this.targetCoin = value;

    this.calcExchage(this.amount);
  }

  loadBalanceRs() {
    this.clientService.getBalanceReal().subscribe(result => {
      this.valueBalanceReal = result.data.toFixed(2);
    });
  }

  loadBalanceBs() {
    this.clientService.getBalanceBs().subscribe(result => {
      this.valueBalanceBs = result.data.toFixed(2);
    });
  }

  loadBalanceUs() {
    this.clientService.getBalanceDolar().subscribe(result => {
      this.valueBalanceDolar = result.data.toFixed(2);
    });
  }

  loadValueRsBs() {
    this.systemSerevice.getValueRealBs().subscribe(result => {
      this.valueBsDay = result.data.toFixed(2);
    });
  }

  loadFeeExchangeRSBs() {
    this.systemSerevice.getFeeEchangeRealBs().subscribe(result => {
      this.feeExchangeBs = result.data;
    });
  }

  loadValueRsUs() {
    this.systemSerevice.getValueRealDolar().subscribe(result => {
      this.valueUsDay = result.data.toFixed(2);
    });
  }
  loadFeeExchangeRsUs() {
    this.systemSerevice.getFeeEchangeRealDolar().subscribe(result => {
      this.feeExchangeUs = result.data;
    });
  }

  calcExchage(total: string) {
    // Remove caracteres não numéricos, exceto ponto decimal
    const numericValue = parseFloat(total.replace(/[^\d.,-]/g, '').replace(',', '.'));

    if (isNaN(numericValue) || numericValue <= 0) {
      // Valor inválido, limpa o resultado e retorna
      this.result = '';
      return;
    }

    this.amount = numericValue;
    this.form.patchValue({
      value: total,
    });

    // console.log(this.form.value);

    if (this.amount > this.valueBalanceReal) {
      // Valor maior que o saldo disponível
      this.result = 'Insufficient balance';
      this.amount = '';
      return;
    }

    if (this.amount > 0 && this.amount <= this.valueBalanceReal) {
      if (this.targetCoin === 2) {
        this.customerFee = this.amount * this.feeExchangeBs;
        this.customerValue = (this.amount - this.customerFee) * this.valueBsDay;
        this.result = this.customerValue.toFixed(2); // Mostra sempre com duas casas decimais
      } else {
        this.customerFee = this.amount * this.feeExchangeUs;
        this.customerValue = (this.amount / this.valueUsDay) + this.customerFee;
        this.result = this.customerValue.toFixed(2); // Mostra sempre com duas casas decimais
      }
    }
  }

  use25() {
    const exchange = (this.valueBalanceReal * 0.25);
    this.form.patchValue({
      value: exchange,
    });

    this.amount = exchange;

    if (this.targetCoin === 2) {
      this.customerFee = exchange * this.feeExchangeBs;
      this.customerValue = (exchange - this.customerFee) * this.valueBsDay;
      this.result = this.customerValue;
    }

    if (this.targetCoin === 3) {
      this.customerFee = exchange * this.feeExchangeUs;
      this.customerValue = (exchange / this.valueUsDay) - this.customerFee;
      this.result = this.customerValue;
    }

  }

  use50() {
    const exchange = (this.valueBalanceReal * 0.50);
    this.form.patchValue({
      value: exchange,
    });

    this.amount = exchange;

    if (this.targetCoin === 2) {
      this.customerFee = exchange * this.feeExchangeBs;
      this.customerValue = (exchange - this.customerFee) * this.valueBsDay;
      this.result = this.customerValue;
    }

    if (this.targetCoin === 3) {
      this.customerFee = exchange * this.feeExchangeUs;
      this.customerValue = (exchange / this.valueUsDay) - this.customerFee;
      this.result = this.customerValue;
    }
  }

  use75() {
    const exchange = (this.valueBalanceReal * 0.75);
    this.form.patchValue({
      value: exchange,
    });

    this.amount = exchange;

    if (this.targetCoin === 2) {
      this.customerFee = exchange * this.feeExchangeBs;
      this.customerValue = (exchange - this.customerFee) * this.valueBsDay;
      this.result = this.customerValue;
    }

    if (this.targetCoin === 3) {
      this.customerFee = exchange * this.feeExchangeUs;
      this.customerValue = (exchange / this.valueUsDay) - this.customerFee;
      this.result = this.customerValue;
    }
  }

  use100() {
    const exchange = (this.valueBalanceReal * 1);
    this.form.patchValue({
      value: exchange,
    });

    this.amount = exchange;

    if (this.targetCoin === 2) {
      this.customerFee = exchange * this.feeExchangeBs;
      this.customerValue = (exchange - this.customerFee) * this.valueBsDay;
      this.result = this.customerValue;
    }

    if (this.targetCoin === 3) {
      this.customerFee = exchange * this.feeExchangeUs;
      this.customerValue = (exchange / this.valueUsDay) - this.customerFee;
      this.result = this.customerValue;
    }
  }

  async exchangeOrder() {
    const loading = await this.loadingCtrl.create({ message: 'Processando...' });
    loading.present();

    if (this.calcExchange(this.amount)) {

      if (this.targetCoin === 2) {
        this.orderService.exchangeRealByBs(this.form.value).subscribe(result => {
          if (result.success) {
            loading.dismiss();
            this.showMessage(result.message);
            this.goToPage('/master/wallet/home');
          } else {
            loading.dismiss();
            this.showMessage(result.message);
          }
        }, error => {
          loading.dismiss();
          this.showMessage(error.message);
        });
      }

      if (this.targetCoin === 3) {
        this.orderService.exchangeRealByDolar(this.form.value).subscribe(result => {
          if (result.success) {
            loading.dismiss();
            this.showMessage(result.message);
            this.goToPage('/master/wallet/home');
          } else {
            loading.dismiss();
            this.showMessage(result.message);
          }
        }, error => {
          loading.dismiss();
          this.showMessage(error.message);
        });
      }
    } else {
      loading.dismiss();
      this.showMessage('Opz... Parece que não ha saldo suficiente!');
    }
  }

  calcExchange(value): boolean {
    if (this.valueBalanceReal >= value) {
      return true;
    } else {
      return false;
    }
  }


  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  goToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }
}
